import { Branch, User, Lookup } from "projects/sepidz-web-framework/src/lib/models";
import { TableRead } from "src/app/frontoffice/salons/model/salon.model";
import { EntityBase } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { SaleMethodBranchModel } from "../../sales/model/sale-method-branch.model";
import { SalePriceType } from "../../catalog/model/sale-price-type.model";
import { Customer, CustomerAddress } from "../../parties/model/customer.model";
import { ReceiptPaymentModel } from "./receiptpayment.model";
import { ClubViewModel } from "./smartclub.model";
import { PrintPolicyPrintTimeEnum } from "../../prints/model/print-policy.model";
import { DepositModel } from "../../catalog/model/deposit.model";
import { NumberValueAccessor } from "@angular/forms";
import { CustomerCategory } from "../../parties/model/customer-categories.model";

export class Invoice extends EntityBase {
  public OriginalValue: InvoiceEntry;
  public CommandId?: number;
  public CommandTitle: string;
  public CommandCode?: number;
  public IsMultiPrint: boolean;
  public IsReceiptPrint: boolean;
  public Changes: InvoiceChangesLookup[];
  public PayableChangeId?: number;
  public PayableChangeTitle: string;
  public PayableChangeCode?: number;
  public NumberOfGuests: number;
  public Description: string;
  public DescKitchen: string;
  public DescCustomer: string;
  public TaxRate: number;
  public TollRate: number;
  public ServiceRate: number;
  public ServiceTax: number;
  public posPaymentIndex: number;
  public ApplyTaxForService: boolean;
  public ApplyTaxForShippingCost: boolean;
  public IgnoreService: boolean;
  public IgnoreShippingCost: boolean;
  public PhoneId?: number;
  public PhoneNumber: string;
  public MultiPhoneNumber: string;
  public AddressId?: number;
  public ChangedByUser?: boolean;
  public CustomerAddres: string;
  public CustomerAddress: CustomerAddress;
  public Customer: Customer;
  public ShippingCost: number;
  public ShippingCostTax: number;
  public CourierShippingCost: number;
  public StatusId?: number;
  public StatusTitle: string;
  public StatusCode?: number;
  public DiscountType?: number;
  public OldStatusCode?: number;
  public TotalNet: number;
  public TotalService: number;
  public TotalTax: number;
  public TotalToll: number;
  public Discount: number;
  public TotalDiscount: number;
  public DiscountPrice: number;
  public IsDiscountPercent: boolean;
  public PreprationDeliveryTime: string;
  public Total: number;
  public hasChangedTable: boolean;
  public TotalWidthRowDiscount: number;
  public RoundingAmount: number;
  public RoundingTypeId?: number;
  public RoundingTypeTitle: string;
  public RoundingTypeCode?: number;
  public PayableTotal: number;
  public PayableTotalLessDiscount: number;
  public Debit: number;
  public isDebit: boolean;
  public AutomaticDebtor: boolean;
  public Credit: number;
  public Tip: number;
  public DriverAssingDate?: string;
  public DriverReturnDate?: Date;
  public ShamsiDriverReturnDate?: string;
  public ShamsiDriverExitDate?: string;
  public DriverReturnTime?: string;
  public NumberingInDate: number;
  public NewNumberingInDate: number;
  public User: User;
  public WaiterId?: number;
  public WaiterName: string;
  public CustomerId: number;
  public CustomerLastName: string;
  public CustomerName: string;
  public CustomerTitle: string;
  public CustomerNumber?: number;
  public CustomerDisplayName: string;
  public TableId?: number;
  public TableTitle: string;
  public SalonTitle: string;
  public TableRead: TableRead;
  public SaleMethodBranch: SaleMethodBranchModel;
  public SaleMethodNatureCode?: number;
  public SaleMethodBranchId: number;
  public OldSaleMethodBranchId: number;
  public SaleMethodBranchTitle: string;
  public CreatedUserName: string;
  public CreatedUserPhoneNumber: string;
  public BranchId: number;
  public ModifiedDateTime: string;
  public ModifiedDateTimeString: string;
  public Branch: Branch;
  public SalePriceTypeId: number;
  public SalePriceType: SalePriceType;
  public DriverAssignments: DriverAssignment;
  public ReceiptPayments: ReceiptPaymentModel[];
  public Items: InvoiceItem[];
  public Cleared: boolean;
  public Completed: boolean;
  public Code: number;
  public TabId: string;
  public SaleMethodId: number;
  public PaymentMethodTypeId: number;
  public PaymentMethodTypeIndex: number;
  public Selected: number;
  public HasChange: boolean;
  public SalonId?: number;
  public Command: Lookup;
  public Status: Lookup;
  public DeliveryCustomerPrintTimeCode: number;
  public PreparationPrintCount: number;
  public CustomerPrintCount: number;
  public LastInvoiceCode: number;
  public LastInvoiceAmount: number;
  public SettlementId: number;
  public HasLocalPrtinter: boolean;
  public FiscalYearId: number;
  public Year?: number;
  public SettlementRefrenceCode: number;
  public IsValidRemain?: boolean;
  public PackingPrice: number;
  public isPackingDisable: boolean;
  public isPackingAutoCalc: boolean;
  public isDebitDisable: boolean;
  public ClubPrice: number;
  public HasClub: boolean;
  public ClubCode: string;
  public ClubViewModel: ClubViewModel;
  public WebId?: number;
  public WebKindId?: number;
  public CurrentUserId: number;
  public CurrentBranchId: number;
  public RowVersion: any;
  public ShamsiCreatedDate: string;
  public SettlementTypeTitle: string;
  public SettlementCode: number;
  PrintPolicyPrintTime: PrintPolicyPrintTimeEnum;
  public HasDeliveryDiscount: boolean;
  public CreateDateTime: string;
  public ModifiedDateTimes: string;
  public LastModifiedUserId: number;
  public HasPaymentLink: boolean;
  public HasFactorLink: boolean;
  public ApplySnap: boolean;
  public createdUserPhoneNUmber: string;
  public InPerson: boolean;
  public PaymentLinkState: number;
  public DeliverCustomerTime: string;
  public OrderConfigurationTime: string;
  public PrintPolicyId?: number;
  public OtherPrintTemplateId?: number;
  public PrintDescription?: string;
  public Deposit: DepositModel;
  public DelinoFactor: boolean;
  public changeDiscountType?: boolean;
  public ClearedUserId?: number;
  public StartTimeTrip?: Date;
  public ComputerName: string;
  public OldTableTitle: string;
  public OldTableId?: number;
  public IsPickUp: boolean;
  public customerDiscountValue?: number;
  public CustomerTotalDebit?: number;
  public SelectedCustomerCategory?: CustomerCategory;
  Service: number;
  constructor() {
    super();
    this.ClubCode = null;
    this.RowVersion = null;
    this.HasClub = false;
    this.isDebit = false;
    this.DiscountType = null;
    this.LastInvoiceCode = 0;
    this.SettlementCode = 0;
    this.SettlementTypeTitle = "";
    this.CurrentUserId = 0;
    this.CurrentBranchId = 0;
    this.ClubPrice = 0;
    this.LastInvoiceAmount = 0;
    this.DiscountPrice = 0;
    this.OriginalValue = null;
    this.CommandId = null;
    this.CommandTitle = "";
    this.CommandCode = 0;
    this.hasChangedTable = false;
    this.Changes = [];
    this.PayableChangeId = null;
    this.PayableChangeTitle = "";
    this.PayableChangeCode = null;
    this.NumberOfGuests = 0;
    this.Description = "";
    this.DescKitchen = "";
    this.DescCustomer = "";
    this.PrintDescription = "";
    this.TaxRate = 0;
    this.TollRate = 0;
    this.ServiceRate = 0;
    this.ServiceTax = 0;
    this.ApplyTaxForService = false;
    this.ApplyTaxForShippingCost = false;
    this.IgnoreService = false;
    this.IgnoreShippingCost = false;
    this.IsDiscountPercent = true;
    this.PhoneId = null;
    this.PhoneNumber = "";
    this.AddressId = null;
    this.CustomerAddress = null;
    this.ShippingCost = 0;
    this.ShippingCostTax = 0;
    this.CourierShippingCost = 0;
    this.StatusId = null;
    this.StatusTitle = "";
    this.StatusCode = 0;
    this.TotalNet = 0;
    this.TotalService = null;
    this.TotalTax = 0;
    this.Discount = 0;
    this.TotalDiscount = 0;
    this.Total = 0;
    this.TotalWidthRowDiscount = 0;
    this.RoundingAmount = 0;
    this.RoundingTypeId = null;
    this.RoundingTypeTitle = "";
    this.DelinoFactor = false;
    this.RoundingTypeCode = null;
    this.PayableTotal = 0;
    this.Debit = 0;
    this.Credit = 0;
    this.Tip = 0;
    this.DriverAssingDate = null;
    this.DriverReturnDate = null;
    this.StartTimeTrip = null;
    this.ShamsiDriverReturnDate = null;
    this.ShamsiDriverExitDate = null;
    this.DriverReturnTime = null;
    this.NumberingInDate = 0;
    this.NewNumberingInDate = 0;
    this.WaiterId = null;
    this.CustomerId = 0;
    this.CustomerName = "";
    this.CustomerNumber = null;
    this.TableId = null;
    this.SaleMethodBranchId = 0;
    this.BranchId = 0;
    this.SalePriceTypeId = 0;
    this.ReceiptPayments = [];
    this.Items = [];
    this.Cleared = false;
    this.Completed = false;
    this.Code = 0;
    this.TabId = "";
    this.CustomerPrintCount = 0;
    this.PreparationPrintCount = 0;
    this.PackingPrice = null;
    this.ShamsiCreatedDate = "";
    this.CreateDateTime = null;
    this.ModifiedDateTime = "";
    this.LastModifiedUserId = 0;
    this.ShamsiCreatedDate = "";
    this.ModifiedDateTime = "";
    this.LastModifiedUserId = 0;
    this.HasPaymentLink = false;
    this.HasFactorLink = false;
    this.PaymentLinkState = null;
    this.DeliverCustomerTime = "";
    this.OrderConfigurationTime = "";
    this.PrintPolicyId = null;
    this.OtherPrintTemplateId = null;
    this.Deposit = null;
    this.CustomerTotalDebit = null;
  }
}
export class DriverAssignInvoiceViewModel {
  public Invoices: AssignInvoiceViewModel[];
  public DriverId: number;
}
export class AssignInvoiceViewModel extends Invoice {
  FactorTime?: Date;
  FactorStringTime: string;
  Address: string;
  DelayTime: boolean;
  TimeOver: boolean;
  CreatedUserName: string;
  AssignmentDateTime: string;
  DriverAssignmentStatus: DriverAssignmentStatus;
  IsPickUp: boolean;
  public DeliveryCustomerPrintTimeCode: number;
  DriverId: number;
}
export class LastInvoiceInformation {
  public Code: number;
  public Amount: number;
  public DelinoInvoiceCount: number;
  public DayOfWeek: string;
}
export class DriverAssignment extends EntityBase {
  public InvoiceId: number;
  public DriverId: number;
  public Invoice: AssignInvoiceViewModel;
  public DeliveredDateTime?: Date;
  public DriverReturnDate: Date;
  public DriverDisplayName : string;
}
export class DriverAssignmentInvoices {
  DriverId: number;
  SelectedInvoices: number[];
}
export class InvoiceItem extends EntityBase {
  public Index: number;
  public Quantity: number;
  public NewQuantity: number;
  public Free: boolean;
  public UnitPrice: number;
  public Price: number;
  public TotalPrice: number;
  public ItemTotal: number;
  public UnitKind?: number;
  public UnitDiscount: number;
  public AdditiveUnitDiscount: number;
  public AdditiveServiceUnitDiscount: number;
  public TotalDiscount: number;
  public RowDiscountPrice: number;
  public UnitService: number;
  public UnitTax: number;
  public UnitToll: number;
  public UnitAdditive: number;
  public UnitAdditiveApplyTaxPrice: number;
  public UnitAdditiveServicePrice: number;
  public UnitAdditiveRowDiscountPrice: number;
  public Description: string;
  public ApplyService: boolean;
  public ApplyTax: boolean;
  public ItemId: number;
  public ItemTitle: string;
  //public Item: Item;
  public InvoiceId: number;
  public InvoiceCode: number;
  public CategoryId?: number;
  public ParentCategoryId?: number;
  public GoodsId?: number;
  public ItemDependencyTypeCode?: number;
  public IsDependent: boolean;
  public Ingredients: string;
  public Ingredients_En: string;
  public Additives: InvoiceItemAdditive[];
  public Descriptions: InvoiceItemDescription[];
  public Tax: number;
  public Toll: number;
  public Service: number;
  public PackingPrice: number;
  public RowDiscount: number;
  public additivePrice: number;
  public showPercent: boolean;
  public IsClubItem: boolean;
  public PrintDisplayOrder: number;
  public SaleMethodBranchId: number;
  public CookingTime: number;
  public OrganizationalDiscount: number;
  public IsOrganizationalDiscount = false;
  constructor() {
    super();
    this.Index = 0;
    this.PrintDisplayOrder = 0;
    this.IsClubItem = false;
    this.AdditiveUnitDiscount = 0;
    this.UnitAdditiveRowDiscountPrice = 0;
    this.additivePrice = 0;
    this.Quantity = 0;
    this.Free = false;
    this.TotalPrice = 0;
    this.UnitPrice = 0;
    this.UnitDiscount = 0;
    this.RowDiscountPrice = 0;
    this.UnitService = 0;
    this.UnitTax = 0;
    this.UnitToll = 0;
    this.UnitAdditive = 0;
    this.Description = "";
    this.ApplyService = false;
    this.ApplyTax = false;
    this.ItemId = 0;
    // this.Item = new Item();
    this.InvoiceId = 0;
    this.Additives = [];
    this.Descriptions = [];
    this.IsDependent = false;
    this.Tax = 0;
    this.Toll = 0;
    this.PackingPrice = 0;
    this.RowDiscount = 0;
    this.RowDiscountPrice = 0;
    this.CookingTime = 0;
    this.OrganizationalDiscount = null;
  }
}
export class InvoiceItemAdditive extends EntityBase {
  public Index: number;
  public UnitPrice: number;
  public MainPrice: number;
  public UnitTax: number;
  public UnitToll: number;
  public UnitService: number;
  public UnitRowDiscount: number;
  public RowDiscount: number;
  public UnitDiscount: number;
  public qty: number;
  public ApplyService: boolean;
  public ApplyTax: boolean;
  public InvoiceItemId: number;
  public AdditiveId: number;
  public AdditiveTitle: string;
  public Tax: number;
  public Toll: number;
  public Service: number;
  public PackingPrice: number;
  public RowDiscountPrice: number;
}
export class InvoiceItemDescription extends EntityBase {
  public InvoiceItemId: number;
  public DescriptionId: number;
  public DescriptionTitle: string;
}
export class InvoiceReceiptPaymentEntry {
  public Amount: number;
  public ReceiptPaymentTypeId: number;
  public ReceiptPaymentTypeTitle: string;
  public ReceiptPaymentTypeCode: number;
  public PaymentMethodTitle: string;
  public PaymentMethodId: number;
}
export class InvoiceItemDescriptionEntry {
  public DescriptionId: string;
}
export class InvoiceItemAdditiveEntry {
  public AdditiveId: number;
}
export class InvoiceItemEntry {
  public Id: number;
  public Quantity: number;
  public Price: number;
  public Descriptions: InvoiceItemDescriptionEntry[];
  public Additives: InvoiceItemAdditiveEntry[];
}
export class InvoiceEntry {
  public Discount: number;
  public TotalService: number;
  public SalePriceTypeId: number;
  public TableId?: number;
  public WaiterId?: number;
  public ShippingCost: number;
  public ApplyTaxForService?: boolean;
  public Debit: number;
  public Credit: number;
  public Tip: number;
  public CustomerId: number;
  public AddressId?: number;
  public Description: string;
  public PayableTotal: number;
  public TotalDiscount: number;
  public DiscountPrice: number;
  public IsDiscountPercent: boolean;
  public PackingPrice: number;
  public StatusCode: number;
  public Items: InvoiceItem[];
  public SaleMethodBranchId: number;
  public SaleMethodBranch: SaleMethodBranchModel;
  public ReceiptPayments: ReceiptPaymentModel[];
  public BranchId: number;
  HasClub: boolean;
  constructor() {
    this.Discount = 0;
    this.StatusCode = 0;
    this.TotalService = 0;
    this.SalePriceTypeId = 0;
    this.TableId = null;
    this.WaiterId = null;
    this.ShippingCost = 0;
    this.ApplyTaxForService = null;
    this.Debit = 0;
    this.Credit = 0;
    this.PackingPrice = 0;
    this.Tip = 0;
    this.CustomerId = 0;
    this.AddressId = null;
    this.Description = "";
    this.PayableTotal = 0;
    this.Items = [];
    this.TotalDiscount = 0;
    this.DiscountPrice = 0;
    this.SaleMethodBranchId = 0;
    this.IsDiscountPercent = false;
    this.ReceiptPayments = [];
    this.BranchId = 0;
  }
  //public ReceiptPayments: InvoiceReceiptPaymentEntry[];
}
export class InvoiceChangesLookup extends EntityBase {
  public InvoiceId: number;
  public Invoice: Invoice;
  public LookupId: number;
  public LookupCode: number;
  public Lookup: Lookup;
  public SaleMethodBranch: SaleMethodBranchModel;
}
export class Rounding extends EntityBase {
  public Amount: number;
  public RoundingTypeId?: number;
  public RoundingTypeTitle: string;
  public RoundingTypeCode?: number;
}
export class DriverAssignmentRead {
  public InvoiceId: number;
  public DriverId: number;
  public DriverAssignmentId: number;
  public Number: number;
  public NumberingInDate: number;
  public InvoiceTotal: number;
  public CustomerName: string;
  public FactorTime?: Date;
  public FactorStringTime: string;
  public ShippingAddress: string;
  public DriverName: string;
  public AllowCancelAssignment: boolean;
  public Status: DriverAssignmentStatus;
  public InvoiceAssignedStatus: InvoiceAssigned;
  public CreatedDate?: Date;
  public AssignmentDateTime: string;
}
export enum InvoiceStatus {
  New = 0,
  Pending = 1,
  Ordering = 2,
  Clearing = 3,
  Cleared = 4,
  Assigned = 5,
  Cancelled = 6,
  Completed = 7,
  Deleted = 8,
}
export enum InvoiceCommand {
  Save = 1,
  PreparationPrint = 2,
  CustomerPrint = 3,
  Clear = 4,
  ClearWithoutPrint = 5,
  Print = 6,
  Assign = 7,
  Unassign = 8,
  Cancel = 9,
  ReprintForPreparation = 10,
  ReprintForCustomer = 11,
  TemporaryRegister = 12,
  Delete = 13,
  MixClear = 20,
  PosPayment = 14,
  TabletPos = 15,
  CustomerTabletPrint = 16,
  ReceiptPrint = 17,
  CustomerFinancialPrint = 21,
  CustomerA5Print = 22,
  CustomerFinancialA5Print = 23,
}
export enum DiscountTypeEnum {
  None = 0,
  HappyHour = 1,
  User = 2,
  Subscription = 4,
  Organization = 5,
}
export enum ItemStateEnum {
  Increase = 1,
  Decrease = 2,
  Remove = 3,
  Clear = 4,
  NoAction = 5,
}
export enum DriverAssignmentStatus {
  Preparing = 0,
  DelayInPreparation = 1,
  ExcessivePreparationDelay = 2,
}
export enum InvoiceAssigned {
  Assigned,
  NotAssigned,
}
export enum InvoiceChanges {
  Discount = 1,
  SalePriceType = 2,
  Table = 3,
  Waiter = 4,
  ShippingCost = 5,
  Service = 6,
  Debit = 7,
  Credit = 8,
  Tip = 9,
  Customer = 10,
  ShippingAddress = 11,
  ItemQuantityPositive = 12,
  ItemQuantityNegative = 13,
  ItemUnitPrice = 14,
  ItemAdditivePositive = 15,
  ItemAdditiveNegative = 16,
  ItemDescription = 17,
  ReceiptPayment = 18,
  Club = 19,
  PackingPrice = 20,
  SaleMethodBranchId = 21,
  BranchId = 22,
}
export enum InvoicePayableChange {
  Positive = 1,
  Negative = 2,
}
export enum InvoiceMode {
  Insert,
  Update,
}
export class DriverAssignGetInvoiceViewModel {
  UntilDate: Date;
}
export class CurrentTime {
  CurrentTimeServer: Date;
}

export enum PaymentLinkState {
  Nothing = 0,
  SentLink = 10,
  DeliveredLink = 20,
  OpenFactorLink = 30,
  Paying = 40,
  Paid = 50,
  FailPayment = 60,
}
export class InvoicePrintLocal {
  public NumberingInDate: number;
  public CreateDateTime: string;
}

export class PosPaymentResponse {
  public IsSuccess: boolean;
  public Message: string;
}
export class DeleteDriverAssignment {
  public Id: number;
  public BranchId: number;
  public DriverId: number;
  public FiscalYearId: number;
  public UnAssignmentDesceription: string;
}
